import { useState } from "react"

/**
 * Custom hook for managing user selection state
 * @returns {Object} Selection state and handlers
 */
export const useUserSelection = () => {
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedUserData, setSelectedUserData] = useState([])

  const handleSelectUser = (user, isSelected) => {
    if (isSelected) {
      setSelectedUsers([...selectedUsers, user._id])
      setSelectedUserData([...selectedUserData, user])
    } else {
      setSelectedUsers(selectedUsers.filter(id => id !== user._id))
      setSelectedUserData(selectedUserData.filter(u => u._id !== user._id))
    }
  }

  const handleSelectAll = (users, isSelected) => {
    if (isSelected) {
      setSelectedUsers(users.map(u => u._id))
      setSelectedUserData([...users])
    } else {
      setSelectedUsers([])
      setSelectedUserData([])
    }
  }

  const handleDeselectAll = () => {
    setSelectedUsers([])
    setSelectedUserData([])
  }

  return {
    selectedUsers,
    selectedUserData,
    setSelectedUsers,
    setSelectedUserData,
    handleSelectUser,
    handleSelectAll,
    handleDeselectAll
  }
}
